var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"icon-left":_vm.icon,"type":_vm.type,"inverted":""}},[_vm._v(" Back ")])
}
var staticRenderFns = []

export { render, staticRenderFns }